import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SEO({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  schema,
  noindex = false,
}) {
  const location = useLocation();
  const canonicalUrl = `https://detekniq.dk${location.pathname}`;

  useEffect(() => {
    // 1. Title
    const finalTitle = title 
      ? `${title} | D.E. TekniQ K/S` 
      : 'D.E. TekniQ K/S | Din lokale el- og energispecialist i Midtjylland';
    document.title = finalTitle;

    // Helper to set or create meta tags
    const setMetaTag = (attrName, attrValue, content) => {
      let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content || '');
    };

    // 2. Meta Description
    const finalDescription = description || 'D.E. TekniQ K/S leverer professionelle, energirigtige og driftssikre løsninger til private, erhverv og landbrug i Kjellerup, Silkeborg, Viborg og omegn.';
    setMetaTag('name', 'description', finalDescription);

    // 3. Open Graph
    setMetaTag('property', 'og:title', ogTitle || title || 'D.E. TekniQ K/S');
    setMetaTag('property', 'og:description', ogDescription || finalDescription);
    setMetaTag('property', 'og:url', canonicalUrl);
    setMetaTag('property', 'og:type', ogType);
    setMetaTag('property', 'og:image', ogImage || 'https://assets.auxodev.dk/assets/c02e6411-90cc-481d-8aeb-e9d9691b4c94/varevogn.jpg');

    // 4. Twitter Card
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', ogTitle || title || 'D.E. TekniQ K/S');
    setMetaTag('name', 'twitter:description', ogDescription || finalDescription);
    setMetaTag('name', 'twitter:image', ogImage || 'https://assets.auxodev.dk/assets/c02e6411-90cc-481d-8aeb-e9d9691b4c94/varevogn.jpg');

    // 5. Robots
    setMetaTag('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

    // 6. Canonical Link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    // 7. Schema Markup (JSON-LD)
    let schemaScript = document.getElementById('seo-schema-markup');
    if (schemaScript) {
      schemaScript.remove();
    }

    if (schema) {
      schemaScript = document.createElement('script');
      schemaScript.id = 'seo-schema-markup';
      schemaScript.type = 'application/ld+json';
      schemaScript.text = JSON.stringify(schema);
      document.body.appendChild(schemaScript);
    }

    return () => {
      // Clean up schema on unmount to avoid duplicates or stale schemas
      const scriptToClean = document.getElementById('seo-schema-markup');
      if (scriptToClean) {
        scriptToClean.remove();
      }
    };
  }, [title, description, ogTitle, ogDescription, ogImage, ogType, schema, canonicalUrl, noindex]);

  return null;
}
